import { activateInlineScripts } from '@otto-ec/global-resources/dom';
import { BaseComponent } from '../../base-component';
import {
    articleInfoTeaserVariationChange,
    articleTeaserVariationChange,
    pointsTeaserVariationChange,
} from '@otto-ec/nexus-registry/promo/up/teaser';

export class UpInfoComponent extends BaseComponent {
    public rootSelector = '.js_pdp_up-info';
    public static shippingCostsProgressBarSelector = '.js_pdp_up-info__shipping-costs-progress-bar'; /*                                                 */
    private visibilityObserver?: MutationObserver;
    private isInitialPageLoad = true;
    private shouldActivateInlineScripts = false;

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.shouldActivateInlineScripts = !this.isInitialPageLoad;
        this.isInitialPageLoad = false;

        const variationId = this.getRootElement().dataset.variationId || '';

        if (this.usesOnExNewDesign()) {
            await this.sendArticleInfoTeaserTargetEvent(variationId);
            this.observeVisibility();
            this.updateVisibility();
            return;
        }

        this.sendUpTeaserTargetEvent(variationId);
        this.sendUpPointsBannerTargetEvent(variationId);
    }

    private usesOnExNewDesign(): boolean {
        return this.getRootElement().classList.contains('pdp_up-info--redesign');
    }

    private sendUpTeaserTargetEvent(variationId: string): void {
        const targetElementBottom = this.getChildElement('.js_pdp_up-info__up-teaser-target');
        articleTeaserVariationChange({
            variationId,
            targetElement: targetElementBottom,
            cdc: false,
        });
    }

    private sendUpPointsBannerTargetEvent(variationId: string): void {
        const targetElement = this.getChildElement('.js_pdp_up-info__up-points-banner-target');
        pointsTeaserVariationChange({
            variationId,
            targetElement: targetElement,
            cdc: false,
        });
    }

    private async sendArticleInfoTeaserTargetEvent(variationId: string): Promise<void> {
        /*                                          */
        if (this.shouldActivateInlineScripts) {
            const infoTeaserEsiElement = document.querySelector<HTMLElement>('.js_pdp_up-info__teaser-esi');
            if (infoTeaserEsiElement) {
                await activateInlineScripts(infoTeaserEsiElement);
            }
        }

        const targetElement = this.getChildElement('.js_pdp_up-info__up-teaser-target');

        articleInfoTeaserVariationChange({
            variationId,
            targetElement,
            cdc: false,
        });
    }

    private observeVisibility(): void {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = new MutationObserver(() => this.updateVisibility());
        this.visibilityObserver.observe(this.getRootElement(), { childList: true, subtree: true });
    }

    private updateVisibility(): void {
        const rootElement = this.getRootElement();
        const headerElement = rootElement.querySelector('.pdp_up-info__header');
        const contentElement = rootElement.querySelector('.js_pdp_up-info__content');
        const dividerElement = rootElement.querySelector('.pdp_up-info__divider');
        const progressWrapperElement = rootElement.querySelector('.pdp_up-info__progress-wrapper');
        const teaserTargetElement = rootElement.querySelector('.js_pdp_up-info__up-teaser-target');
        const shippingProgressElement = rootElement.querySelector(UpInfoComponent.shippingCostsProgressBarSelector);

        const hasProgressContent = this.hasResolvedContent(shippingProgressElement);
        const hasTeaserContent = this.hasResolvedContent(teaserTargetElement);
        const shouldShowComponent = hasProgressContent || hasTeaserContent;
        const shouldShowHeaderAndFrame = shouldShowComponent && !this.hasCombinedInfoTeaser(teaserTargetElement);
        const shouldShowDivider = shouldShowHeaderAndFrame && hasProgressContent && hasTeaserContent;

        rootElement.classList.toggle('pdp_up-info--visible', shouldShowComponent);
        headerElement?.classList.toggle('pdp_up-info__header--visible', shouldShowHeaderAndFrame);
        dividerElement?.classList.toggle('pdp_up-info__divider--visible', shouldShowDivider);
        progressWrapperElement?.classList.toggle('pdp_up-info__progress-wrapper--visible', hasProgressContent);

        contentElement?.setAttribute('elevation-level', shouldShowHeaderAndFrame ? 'stacked' : 'canvas');
    }

    private hasCombinedInfoTeaser(teaserTargetElement: Element | null): boolean {
        return !!teaserTargetElement?.querySelector('#up-combined-info-teaser-container');
    }

    private hasResolvedContent(element: Element | null): boolean {
        if (!element) {
            return false;
        }
        for (const childNode of Array.from(element.childNodes)) {
            if (childNode.nodeType == Node.ELEMENT_NODE) {
                return true;
            }
        }
        return false;
    }
}
